import axiosInstance from './axiosInstance'

export type TaskPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT'
export type TaskStatus   = 'PENDING' | 'IN_PROGRESS' | 'DONE' | 'CANCELLED'

export interface AuditUser {
  id:        string
  name:      string
  email:     string
  avatarUrl: string | null
}

export interface LeadTask {
  id:           string
  leadId?:                string | null
  leadName?:              string | null
  dealId?:                string | null
  dealName?:              string | null
  salesId?:               string | null
  salesTitle?:            string | null
  retentionCustomerId?:   string | null
  retentionCustomerName?: string | null
  contactId?:             string | null
  contactName?:           string | null
  source?:                'LEAD' | 'DEAL' | 'SALES' | 'RETENTION' | 'CONTACT' | string
  title:        string
  description:  string | null
  priority:     TaskPriority
  status:       TaskStatus
  dueDate:      string | null
  reminderTime: string | null
  assignedTo:   AuditUser | null
  createdBy:    AuditUser | null
  completedAt:  string | null
  createdAt:    string
  updatedAt:    string
}

export interface PaginatedLeadTasks {
  items: LeadTask[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface LeadTaskFilters {
  search?: string
  statuses?: string[]
  ownerIds?: string[]
  from?: string
  to?: string
  // SuperAdmin / Org Admin: narrow by org / LOB
  orgIds?: string[]
  lobIds?: string[]
}

export interface CreateLeadTaskPayload {
  title:        string
  description?: string
  priority?:    TaskPriority
  dueDate?:     string   // ISO string
  reminderTime?: string  // ISO string
  assignedToId?: string
}

export interface UpdateLeadTaskPayload {
  title?:        string
  description?:  string
  priority?:     TaskPriority
  status?:       TaskStatus
  dueDate?:      string
  reminderTime?: string
  assignedToId?: string
}

export const leadTasksApi = {
  getAllForCalendar: (lobIds?: string[]) =>
    axiosInstance
      .get<{ data: LeadTask[] }>('/lead-tasks', { params: lobIds?.length ? { lobIds: lobIds.join(',') } : undefined })
      .then(r => r.data.data),

  getPagedForActivity: (page: number, pageSize: number, filters?: LeadTaskFilters): Promise<PaginatedLeadTasks> =>
    axiosInstance
      .get<{ data: PaginatedLeadTasks }>('/lead-tasks/paged', {
        params: { page, pageSize, ...filters }
      })
      .then(r => r.data.data),

  getAll: (leadId: string) =>
    axiosInstance
      .get<{ data: LeadTask[] }>(`/leads/${leadId}/tasks`)
      .then(r => r.data.data),

  create: (leadId: string, payload: CreateLeadTaskPayload) =>
    axiosInstance
      .post<{ data: LeadTask[] }>(`/leads/${leadId}/tasks`, payload)
      .then(r => r.data.data),

  update: (leadId: string, taskId: string, payload: UpdateLeadTaskPayload) =>
    axiosInstance
      .patch<{ data: LeadTask[] }>(`/leads/${leadId}/tasks/${taskId}`, payload)
      .then(r => r.data.data),
}
